export const CONTAINMENT_STYLE = [
    { label: 'PVC', value: 'PVC' },
    { label: 'Box', value: 'Box' },
    { label: 'Funeral director to provide vessel', value: 'Funeral director to provide vessel' },
    { label: 'Our stock', value: 'Our stock' },
    { label: 'Family to provide vessel', value: 'Family to provide vessel' }
]